import { render, staticRenderFns } from "./OverviewFile.vue?vue&type=template&id=47fde9fc"
import script from "./OverviewFile.vue?vue&type=script&lang=js"
export * from "./OverviewFile.vue?vue&type=script&lang=js"
import style0 from "./OverviewFile.vue?vue&type=style&index=0&id=47fde9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports